import React from 'react'
import { FlightsCreditDetails } from 'components/Flights/types'

import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TermsAndConditionsList from './TermsAndConditionsList'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  creditDetails: FlightsCreditDetails
}

function RebookingConditions(props: Props) {
  const { creditDetails, creditDetails: { carrierName } } = props

  return <VerticalSpacer gap={20}>
    <Heading variant="heading3" align="center">
      Book your new flights with your {carrierName} flight credit
    </Heading>
    <VerticalSpacer gap={8}>
      <BodyText variant="large" weight="bold">
        Please note this page is only accessible through the email.
      </BodyText>
      <BodyText variant="large">
        You are able to navigate to other areas of Luxury Escapes. However by doing this you will not be able to return to this page. You will need to go back to your email and restart the booking process.
      </BodyText>
    </VerticalSpacer>
    <BodyText variant="large">
      There are additional terms and conditions associated with using these credits to book flights. These include:
    </BodyText>
    <TermsAndConditionsList {...creditDetails} />
  </VerticalSpacer>
}

export default RebookingConditions
